import { Close } from "@mui/icons-material";
import { Divider, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import CustomInput from "../../shared/CustomInput2";
import CustomButton from "../../shared/CustomButton2";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import {
  addSpecificationTypes,
  updateSpecificationTypes,
} from "../../Services/SpecificationTypes";
import FormSelectCategories from "./FormSelectCategories";

const AddSpecificationType = ({ open, setOpen, rowData, setRowData }) => {
  const [category, setCategory] = useState();
  const [specificationTypeName, setSpecificationTypeName] = useState("");
  const client = useQueryClient();

  const handleClose = () => {
    setOpen(false);
    setSpecificationTypeName("");
    setRowData();
  };

  const { mutate: addSpecificationTypeMutation } = useMutation(
    addSpecificationTypes,
    {
      onSuccess: (res) => {
        if (res?.data?.response_code === 200) {
          toast.success(res?.data?.message);
          client.invalidateQueries("specificationTypes");
          handleClose();
        } else {
          toast.error(res?.data?.message);
        }
      },
    }
  );

  const { mutate: updateSpecificationTypeMutation } = useMutation(
    updateSpecificationTypes,
    {
      onSuccess: (res) => {
        if (res?.data?.response_code === 200) {
          toast.success(res?.data?.message);
          client.invalidateQueries("specificationTypes");
          handleClose();
        } else {
          toast.error(res?.data?.message);
        }
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!rowData) {
      addSpecificationTypeMutation({
        maincategory: category,
        specification_name: specificationTypeName,
      });
    } else {
      updateSpecificationTypeMutation({
        specification_type_id: rowData.id,
        maincategory: category,
        specification_name: specificationTypeName,
      });
    }
  };

  useEffect(() => {
    if (rowData) {
      setSpecificationTypeName(rowData.specification_name);
    }
  }, [rowData]);

  return (
    <Modal open={open} onClose={handleClose}>
      <div className="absolute w-2/5 -translate-x-1/2 -translate-y-1/2 bg-white rounded-md top-1/2 left-1/2">
        <div className="relative">
          <Close
            className="absolute cursor-pointer right-4 top-4"
            onClick={handleClose}
          />
          <div className="p-4 text-2xl font-semibold text-center">
            Add Specification Types
          </div>
          <Divider />
          <form onSubmit={handleSubmit} className="flex flex-col gap-4 p-4">
            <FormSelectCategories
              category={category}
              setCategory={setCategory}
              categoryId={rowData?.maincategory}
            />
            <CustomInput
              label="Specification Type"
              value={specificationTypeName}
              onChange={(event) => setSpecificationTypeName(event.target.value)}
            />
            <div className="flex justify-end">
              <CustomButton type="submit" variant="outlined">
                {rowData ? "Update" : "Add"}
              </CustomButton>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default AddSpecificationType;
